export { default as DocsLink, DOCS_URL } from './DocsLink';
export { default as Link, NEW_TAB_PROPS } from './Link';
export { default as MailToLink } from './MailToLink';
export { default as RouterLink } from './RouterLink';
export { default as SupportLink } from './SupportLink';
import Link from './Link';

export default Link;
